import { formatDate } from './dateUtils';

const normalize = (value) => String(value ?? '').toLowerCase();

export const matchesSearchQuery = (values, searchTerm) => {
  const query = searchTerm.trim().toLowerCase();
  if (!query) return true;
  return values.some((value) => normalize(value).includes(query));
};

export const getCustomerSearchValues = (customer) => [
  customer.id,
  customer.name,
  customer.company_name,
  customer.ph1,
  customer.ph2,
  customer.email,
  customer.place,
  customer.address,
];

export const getBookingSearchValues = (booking) => [
  booking.id,
  booking.customer,
  booking.company_name,
  booking.booking_date,
  formatDate(booking.booking_date),
  booking.dispatch_date,
  formatDate(booking.dispatch_date),
  booking.return_date,
  booking.return_date ? formatDate(booking.return_date) : '',
  booking.total_amount,
  booking.status,
  booking.status?.replace(/_/g, ' '),
];

export const customerMatchesSearch = (customer, searchTerm) =>
  matchesSearchQuery(getCustomerSearchValues(customer), searchTerm);

export const bookingMatchesSearch = (booking, searchTerm) =>
  matchesSearchQuery(getBookingSearchValues(booking), searchTerm);
